module.exports = __webpack_public_path__ + "2ea3c378bb88a51a96aed7aaf7992e05.MP3";